import React from "react";
import { RefineCrudCreateProps } from "@pankod/refine-ui-types";
import { Create } from "@pankod/refine-antd";
import classNames from "classnames";
import "../styles.css";

export interface ICreateProps extends RefineCrudCreateProps {
  fullWidth?: boolean;
  noPadding?: boolean;
}
// TODO
export const RelationshipMatrixCreate: React.FC<ICreateProps> = ({
  saveButtonProps,
  title,
  children,
  wrapperProps,
  contentProps,
  headerProps,
  fullWidth,
  noPadding,
  ...props
}) => {
  const hasTitle = title !== "";

  return (
    <Create
      wrapperProps={{
        className: classNames(
          { "crud-container-width": !fullWidth },
          {
            "hide-heading": !hasTitle,
          }
        ),
        ...wrapperProps,
      }}
      goBack={null}
      saveButtonProps={saveButtonProps}
      headerButtons={<></>}
      breadcrumb={<></>}
      contentProps={{
        bodyStyle: noPadding ? { padding: "0" } : { padding: "24px 0" },
        ...contentProps,
      }}
      headerProps={{
        className: classNames({ "crud-container-no-padding": noPadding }),
        ...headerProps,
      }}
      footerButtonProps={{
        style: { flexWrap: "wrap", gap: "8px", float: "right" },
      }}
      title={title}
      {...props}
    >
      {children}
    </Create>
  );
};
